import { orderUploadErrorsModalStyles } from "@insite/content-library/Components/OrderUploadErrorsModal";
import DataTableCellBase from "@insite/mobius/DataTable/DataTableCellBase";
import { css } from "styled-components";

orderUploadErrorsModalStyles.dataTable = {
    cssOverrides: {
    table: css`
    margin-top: 15px;
        >thead{
            >tr{
                >${DataTableCellBase}{
                    background: transparent;
                }
            }
        }
    `,
    },
}

orderUploadErrorsModalStyles.tableBody = {
    css: css`
    >tr[class^="DataTableRowStyle"] {
        &:nth-child(even){
            background: transparent;
        }
    }
    `
}